import { useRequiredContext } from "@redotech/react-util/context";
import { memo } from "react";
import { Flex } from "../../flex";
import { Text } from "../../text";
import { TrackingPageContext } from "../context/tracking-page-context";

export const Header = memo(function Header() {
  const { pageSettings } = useRequiredContext(TrackingPageContext);

  return (
    <Flex
      align="center"
      height="full"
      justify="center"
      style={{
        backgroundColor: pageSettings?.blockSettings.backgroundColor,
        borderRadius: pageSettings?.blockSettings.borderRadius,
        fontFamily: pageSettings?.typography.headerFontFamily,
        color: pageSettings?.typography.headerFontColor,
      }}
    >
      <Text
        fontSize="2xl"
        fontWeight="bold"
        style={{
          fontFamily: pageSettings?.typography.headerFontFamily,
          color: pageSettings?.typography.headerFontColor,
        }}
      >
        Header
      </Text>
    </Flex>
  );
});
